<template>
    <div class="home schema-survey">
        <div class="section">
            <section class="container">
                <h4 class="title page-title has-text-centered has-padding-v-50 is-4">Property Industry Data Schema Survey</h4>

              <section v-if="step == 0">
                  <p class="content"><b>Welcome to the Data Schema Survey</b>,<br>
                    We have  created a voting system for all the fields required in the estate and lettings industry<br>
                    Each supplier has the opportunity to vote for the fields they require so we can make a standard format that works for all users in the industry<br><br>
                    <b>Instructions</b>
                    <br>
                    Click on each section that applies to your company/product and from each list select the fields you require<br>
                    You can log out and change/add to your vote whenver you need before the closing date on 1st October 2019<br>
                    The field will be highlighted in blue to show which fields you have voted for.<br>
                    When you have made your selection, please click save.<br>
                  </p>
                  <b-button class="btn-next" @click="step += 1">Let's start</b-button>
              </section>

              <section v-if="step == 1">
                  <div class="columns">
                      <div class="column">
                          <b-field label="Schema">
                              <b-select placeholder="" v-model="currentSchema" expanded>
                                  <option
                                      v-for="option in schemaOptions"
                                      :value="option"
                                      :key="option">
                                      {{ option }}
                                  </option>
                              </b-select>
                          </b-field>
                      </div>
                      <div class="column schema-survey__add-field">
                          <div class="control" v-if="addNewOpen">
                                <!-- <label>What section should we use for "{{ fieldName }}"?</label>
                                <select class="select" v-model="selectedSection">
                                    <option value=""></option>
                                    <option v-for="sectionName in sortedFieldsKeys" :value="sectionName">{{ sectionName }}</option>
                                </select> -->
                                <b-field :label="'What section should we use for \'' + fieldName +'\' ?'">
                                    <b-select v-model="selectedSection" expanded>
                                        <option
                                            v-for="sectionName in sortedFieldsKeys"
                                            :value="sectionName"
                                            >
                                            {{ sectionName }}
                                        </option>
                                    </b-select>
                                </b-field>
                                <div class="schema-survey__add-field__buttons">
                                    <b-button @click.prevent="cancelAddNew" type="is-text">Cancel</b-button>
                                    <b-button class="btn-save" @click.prevent="nextAddNew" v-if="selectedSection != ''">Save</b-button>
                                </div>
                          </div>
                          <b-field label="Find or add a Field" v-if="!addNewOpen">
                              <b-autocomplete
                                  v-model="fieldName"
                                  ref="autocomplete"
                                  :data="filteredFields"
                                  placeholder="e.g. Address"
                                  @select="option => {selectField(option)}">
                                  <template slot="header">
                                      <a @click="showAddField">
                                          <span> Add new... </span>
                                      </a>
                                  </template>
                                  <template slot-scope="props">
                                    {{props.option.schemaId}}: {{props.option.field}}
                                  </template>
                                  <template slot="empty">No results for {{fieldName}}</template>
                              </b-autocomplete>
                          </b-field>
                      </div>
                  </div>



                <section class="columns schema-survey__tags" v-for="sectionName in sortedFieldsKeys">
                    <div class="column">
                        <h3 class="title is-4">{{sectionName}}</h3>
                        <b-button v-for="field in sortedFields[sectionName]"
                            rounded
                            :type="field.selected ? 'is-selected' : 'is-light'"
                            icon-left="tag"
                            @click="markSelected(field.index)">
                          {{field.field}}
                        </b-button>
                    </div>
                </section>

                <b-button class="btn-next" @click="vote">Vote</b-button>
              </section>

            </section>
        </div>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
  name: 'home',
  data() {
    return {
      addNewOpen: false,
      selectedSection: '',
      step: 0,
      fields: [],
      fieldName: '',
      currentSchema: 'Property',
      selected: null,
      schemaOptions: {
        Property: 'Property',
        Applicant: 'Applicant',
        Vendor: 'Vendor',
        Tenant: 'Tenant',
        Landlord: 'Landlord',
        Agent: 'Agent',
        Solicitor: 'Solicitor',
        Contractor: 'Contractor',
        Sales: 'Sales Progression',
        Lettings: 'Lettings Progression',
        Tenancies: 'Tenancies'
      },
      sectionOptions: {

      }
    };
  },
  async created() {
    this.fields = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/schema/'+this.currentSchema,
      method: 'GET',
    });
  },
  watch: {
    currentSchema: async function(newval, oldval) {
      this.isLoading = true;
      this.fields = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: "/schema/"+newval,
        method: "GET",
      });
      this.isLoading = false;
    },
  },
  computed: {
    sortedFields() {
      const fields = {};
      this.fields.map((field, index) => {
        if(fields[field.section] == null) {
          fields[field.section] = [];
        }
        fields[field.section].push({
          index,
          schemaId: field.schemaId,
          section: field.section,
          fieldId: field.fieldId,
          field: field.field,
          selected: field.selected
        });
      });
      return fields;
    },

    sortedFieldsKeys() {
      return Object.keys(this.sortedFields);
    },

    filteredFields() {
      return this.fields.filter(option => {
        return this.fieldName ? option.field
          .toString()
          .toLowerCase()
          .indexOf(this.fieldName.toLowerCase()) >= 0 : false;
      })
    },
  },
  methods: {
    markSelected(index) {
      this.fields[index].selected = !this.fields[index].selected;
    },

    selectField(field) {
      field.selected = !field.selected;
    },

    async vote() {
      const voted = this.fields.filter(field => field.selected);

      await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/schema/vote',
        method: 'POST',
        body: {
          schema: this.currentSchema,
          voted
        }
      });
      this.$dialog.alert({
        title: 'Votes saved!',
        message: `Thank you for contributing to this survey, your vote is saved.`,
        type: 'is-success',
        confirmText: 'Okay!',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'

      });

      this.fields = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/schema/'+this.currentSchema,
        method: 'GET',
      });
    },

    cancelAddNew() {
      this.fieldName = '';
      this.selectedSection = '';
      this.addNewOpen = false;
    },
    nextAddNew() {
      this.fields.push({
        "field":this.fieldName,
        "schemaId":this.currentSchema,
        "section":this.selectedSection,
        "votes":1,
        "fieldId":"suggestion."+(new Date()).getTime(),
        "selected":true
      });
      this.fieldName = '';
      this.selectedSection = '';
      this.addNewOpen = false;
      this.$dialog.alert({
        title: 'New field saved!',
        message: `Thank you for suggesting this new field, we will consider it for vote.`,
        type: 'is-success',
        confirmText: 'Okay!',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'
      });
    },
    showAddField() {
      //this.fieldName
      if (!this.fieldName || (this.fieldName && this.fieldName.length < 2)) {
        this.$dialog.alert({
          title: 'Nothing to add',
          message: `Please, make sure you write something with more than one character.`,
          type: 'is-error',
          confirmText: 'Okay!',
          hasIcon: true,
          icon: 'check-cross',
          iconPack: 'fa'
        });
        return;
      }
      this.addNewOpen = true;
      /*
      this.$dialog.prompt({
        message: `What's the section name?`,
        confirmText: 'Add',
        onConfirm: (value) => {
          this.fields.push({
            schemaId: this.currentSchema,
            field: null,
            section: value,
            votes: 0
          })
        }
      });
      this.$dialog.alert({
        title: 'Votes saved!',
        message: `Thank you for contributing to this survey, your vote is saved.`,
        type: 'is-success',
        confirmText: 'Okay!',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'
      });
      */
    },

  },
};
</script>

<style lang="scss">
</style>
